exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".OrganizationsSearch-f26807f0{max-width:640px;margin:30px auto}\n", ""]);

// Exports
exports.locals = {
	"OrganizationsSearch": "OrganizationsSearch-f26807f0"
};